import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-notification-create',
  templateUrl: './notification-create.component.html',
  styleUrls: ['./notification-create.component.scss']
})
export class NotificationCreateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
